<div class="questionnaire-box">
  <h3 class="mb-3">{{ questionnaire?.questionnaireDescription }}</h3>
  <ng-container *ngFor="let key of formKeys; let i = index">
    <ng-container *ngIf="!key.hidden">
      <div class="questionnaire-item-box">
        <div class="questionnaire-item-question">
          <p class="m-0">{{ key.label }}</p>
        </div>
        <div class="questionnaire-item-answer" [formGroup]="form">
          <ng-container [ngSwitch]="key?.type">
            <ng-container *ngSwitchCase="'INPUT'">
              <div class="input-with-icon">
                <mat-form-field appearance="outline" class="flex-input">
                  <input
                    matInput
                    [formControlName]="key?.controlName"
                    [id]="key?.controlName"
                  />
                </mat-form-field>
                <ng-container
                  *ngIf="
                    key?.hasAnagraficaModalButton &&
                    !key?.alreadyExistsInRegistry
                  "
                >
                  <button
                    mat-icon-button
                    class="icon-button align-icon"
                    [ngClass]="{
                      'disabled-icon': key?.disableAnagraficaModalButton
                    }"
                    matTooltip="Visualizza Soggetto"
                    (click)="openSubjectModal(key)"
                    [disabled]="key?.disableAnagraficaModalButton"
                  >
                    <mat-icon fontIcon="visibility" class="eye-icon"></mat-icon>
                  </button>
                  <button
                    mat-icon-button
                    class="icon-button align-icon"
                    [ngClass]="{
                      'disabled-icon': key?.disableAnagraficaModalButton
                    }"
                    matTooltip="Cancella Soggetto"
                    (click)="removeSubject(key)"
                    [disabled]="key?.disableAnagraficaModalButton"
                  >
                    <mat-icon fontIcon="delete" class="remove-icon"></mat-icon>
                  </button>
                </ng-container>
                <ng-container
                  *ngIf="
                    key?.hasAnagraficaModalButton &&
                    key?.alreadyExistsInRegistry
                  "
                >
                  <mat-icon
                    class="info-icon"
                    matTooltip="Soggetto già anagrafato. Non sono necessarie altre azioni."
                    matTooltipPosition="above"
                    fontIcon="info_outline"
                  ></mat-icon>
                </ng-container>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'RADIO'">
              <mat-radio-group
                aria-label="Select an option"
                [formControlName]="key?.controlName"
              >
                <mat-radio-button value="1" [disabled]="key?.readonly"
                  >Sì</mat-radio-button
                >
                <mat-radio-button value="0" [disabled]="key?.readonly"
                  >No</mat-radio-button
                >
              </mat-radio-group>
            </ng-container>
            <ng-container *ngSwitchCase="'SELECT'">
              <mat-form-field class="w-100" appearance="outline">
                <mat-select [id]="key?.id" [formControlName]="key?.controlName">
                  <ng-container *ngFor="let option of key?.options">
                    <mat-option [value]="option.key">
                      {{ option.value }}
                    </mat-option>
                  </ng-container>
                </mat-select>
              </mat-form-field>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <!-- TODO definire default? -->
            </ng-container>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>
